import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const MONTH_MAP_SHORT: Record<number, string> = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
};

export type FormatMomentsTimeFn = (timestamp: number | string | Date) => string;

/**
 * 格式化时间为“今天时间”、“昨日时间”或“完整时间”
 * @returns 格式化后的时间字符串
 */
export function useMomentsTime(): {
  formatMomentsTime: FormatMomentsTimeFn;
} {
  const { t } = useTranslation();

  const formatMomentsTime = useCallback<FormatMomentsTimeFn>((timestamp) => {
    const date =
      timestamp instanceof Date ? timestamp : new Date(timestamp);
    const now = new Date();

    const diffMs = now.getTime() - date.getTime();
    const diffMinutes = Math.floor(diffMs / (60 * 1000));
    const diffHours = Math.floor(diffMs / (60 * 60 * 1000));

    const startOfToday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );

    const startOfYesterday = new Date(startOfToday);
    startOfYesterday.setDate(startOfToday.getDate() - 1);

    const pad = (n: number) => String(n).padStart(2, '0');
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    // 当天
    if (date >= startOfToday) {
      // 1分钟内（刚刚）
      // if (diffMinutes < 1) {
      //   return t('format_moments_time.just_now');
      // }
      // 1小时内（20分钟前）
      // if (diffMinutes < 60) {
      //   return t('format_moments_time.minute_ago', { minutes: diffMinutes });
      // }
      // 1~8小时内（3小时前）
      // if (diffHours <= 8) {
      //   return t('format_moments_time.hour_ago', { hours: diffHours });
      // }
      // 8小时以上（今天 10:30）
      return t('format_moments_time.today', { time: `${hours}:${minutes}` });
    }

    // 昨天（昨日10:30）
    if (date >= startOfYesterday && date < startOfToday) {
      return t('format_moments_time.yesterday', { time: `${hours}:${minutes}` });
    }

    // 更早
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    return t('format_moments_time.year', {
      year,
      monthEn: MONTH_MAP_SHORT[month],
      monthZn: month,
      day,
      hours,
      minutes,
    });
  }, []);

  return { formatMomentsTime };
}
